import { doc, getDoc, setDoc, addDoc, collection } from 'firebase/firestore';
    import { db } from '../lib/firebase';
    import { apiRequest } from '../lib/api';

    class EmailService {
      constructor() {
        this.smtpConfig = null;
        this.isConfigured = false;
      }

      async initialize() {
        try {
          const config = await this.getSmtpConfig();
          if (config && config.host && config.user) {
            this.smtpConfig = config;
            this.isConfigured = true;
          }
        } catch (error) {
          console.error('❌ Error initializing SMTP:', error);
        }
      }

      async getSmtpConfig() {
        try {
          const configDoc = await getDoc(doc(db, 'emailConfig', 'smtp-config'));
          return configDoc.exists() ? configDoc.data() : null;
        } catch (error) {
          return null;
        }
      }

      async saveSmtpConfig(config) {
        try {
          await setDoc(doc(db, 'emailConfig', 'smtp-config'), {
            ...config,
            type: 'smtp',
            updatedAt: new Date().toISOString()
          });
          this.smtpConfig = config;
          this.isConfigured = true;
          return { success: true };
        } catch (error) {
          return { success: false, message: error.message };
        }
      }

      // ✅ IMPROVED: Use centralized apiRequest for robustness
      async sendDirectEmail(emailData) {
        try {
          // apiRequest handles URL construction and error parsing automatically
          const result = await apiRequest('/send-email', {
            body: JSON.stringify(emailData)
          });
          return { success: true, ...result };
        } catch (error) {
          return { success: false, message: error.message };
        }
      }

      async logEmailForSending(emailData) {
        if (!this.isConfigured) return { success: false, message: 'SMTP not configured' };
        try {
          const logData = {
            ...emailData,
            status: 'pending',
            createdAt: new Date().toISOString()
          };
          const docRef = await addDoc(collection(db, 'emailLogs'), logData);
          return { success: true, logId: docRef.id };
        } catch (error) {
          return { success: false, message: error.message };
        }
      }

      async sendTestEmail(to, appSettings) {
        return this.sendDirectEmail({
          to,
          subject: `Test Email from ${appSettings.companyName}`,
          html: `<p>This is a test email from your backend.</p>`
        });
      }

      async sendPaymentReminder(student, parent, overdueAmount, sessions, appSettings) {
        const subject = `Payment Reminder for ${student.studentName}`;
        const body = `<p>Dear ${parent.firstName},</p><p>Please pay ${overdueAmount}.</p>`;
        return this.logEmailForSending({ to: parent.email, subject, body });
      }

      async sendCustomMessage(student, parent, message, appSettings) {
        return this.logEmailForSending({
          to: parent.email,
          subject: `Message from ${appSettings.companyName}`,
          body: `<p>${message}</p>`
        });
      }

      async sendPaymentConfirmation(student, parent, transaction, appSettings) {
        return this.logEmailForSending({
          to: parent.email,
          subject: `Payment Confirmation`,
          body: `<p>Received ${transaction.amount}</p>`
        });
      }

      isEmailConfigured() {
        return this.isConfigured;
      }
    }

    const emailService = new EmailService();
    export default emailService;